/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerRef,
  CashDrawerRefOptional,
  CashDrawerRefMetaI,
  CashDrawerRefTrackedI,
} from "./cash-drawer-ref";
import { CashDrawerRefTracked, CashDrawerRefMeta } from "./cash-drawer-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterFull,
  PrinterFullOptional,
  PrinterFullMetaI,
  PrinterFullTrackedI,
} from "./printer-full";
import { PrinterFullTracked, PrinterFullMeta } from "./printer-full";

/**
 *
 * @export
 * @interface PrinterInternal
 */
export interface PrinterInternalOptional extends PrinterFullOptional {
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerMAC?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerName?: string;
  /**
   *
   * @type {boolean}
   * @memberof PrinterInternal
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterInternal
   */
  isNew?: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof PrinterInternal
   */
  cashDrawer?: CashDrawerRefOptional;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerPasswordHash?: string;
}

export interface PrinterInternal extends PrinterInternalOptional, PrinterFull {
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerMAC: string;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerUser?: string;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerName?: string;
  /**
   *
   * @type {boolean}
   * @memberof PrinterInternal
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterInternal
   */
  isNew?: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof PrinterInternal
   */
  cashDrawer?: CashDrawerRef;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerPasswordHash?: string;
}

export interface PrinterInternalTrackedI extends PrinterFullOptional {
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerMAC?: string;
  printerMACIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerUser?: string;
  printerUserIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerName?: string;
  printerNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterInternal
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PrinterInternal
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {CashDrawerRef}
   * @memberof PrinterInternal
   */
  cashDrawer?: CashDrawerRefTrackedI;
  cashDrawerIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PrinterInternal
   */
  printerPasswordHash?: string;
  printerPasswordHashIsSet: boolean;
}

transformDatesMap.set("PrinterInternal", function (model: PrinterInternal) {
  const transformDatescashDrawer = transformDatesMap.get("CashDrawerRef");
  if (transformDatescashDrawer && model.cashDrawer) {
    transformDatescashDrawer(model.cashDrawer);
  }
});

export type PrinterInternalMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  printerMAC: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerUser: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printerName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  cashDrawer: PropertyMeta<CashDrawerRefMetaI>;
  //isDate: false
  //isDatetime: false
  printerPasswordHash: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PrinterInternalMeta: PrinterInternalMetaI =
  {} as PrinterInternalMetaI;
PrinterInternalMeta = typeMeta("PrinterInternal", {
  printerMAC: propertyMeta(
    "printerMAC",
    false,
    true,
    true,
    MetaTypesBase.string,
  ),
  printerUser: propertyMeta(
    "printerUser",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  printerName: propertyMeta(
    "printerName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  cashDrawer: propertyMeta(
    "cashDrawer",
    false,
    false,
    false,
    CashDrawerRefMeta,
  ),
  printerPasswordHash: propertyMeta(
    "printerPasswordHash",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PrinterInternalMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PrinterFullMeta]);
  metaI.printerMAC.inheritedFrom = PrinterFullMeta.printerMAC;
  metaI.printerUser.inheritedFrom = PrinterFullMeta.printerUser;
  metaI.printerName.inheritedFrom = PrinterFullMeta.printerName;
  metaI.isDeleted.inheritedFrom = PrinterFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = PrinterFullMeta.isNew;
  metaI.cashDrawer.inheritedFrom = PrinterFullMeta.cashDrawer;
});

export class PrinterInternalTracked
  extends PrinterFullTracked
  implements PrinterInternalTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  printerMAC__I?: string = undefined;

  get printerMACIsSet() {
    return this.printerMAC !== undefined;
  }
  set printerMACIsSet(v: boolean) {}
  set printerMAC(v: undefined | string) {
    if (v !== undefined) {
      this.printerMAC__I = v;
      this.printerMACIsSet = true;
    } else {
      this.printerMAC__I = v || undefined;
      this.printerMACIsSet = true;
    }
    this.changeTracker = true;
  }
  get printerMAC() {
    return this.printerMAC__I;
  }
  printerUser__I?: string = undefined;
  printerUserIsSet: boolean = false;
  set printerUser(v: undefined | string) {
    if (v !== undefined) {
      this.printerUser__I = v;
      this.printerUserIsSet = true;
    } else {
      this.printerUser__I = v || undefined;
      this.printerUserIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerUser() {
    return this.printerUser__I;
  }
  printerName__I?: string = undefined;
  printerNameIsSet: boolean = false;
  set printerName(v: undefined | string) {
    if (v !== undefined) {
      this.printerName__I = v;
      this.printerNameIsSet = true;
    } else {
      this.printerName__I = v || undefined;
      this.printerNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerName() {
    return this.printerName__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  cashDrawer__I?: CashDrawerRefTracked = undefined;
  cashDrawerIsSet: boolean = false;
  set cashDrawer(v: undefined | CashDrawerRefTracked) {
    if (v !== undefined) {
      this.cashDrawer__I = v;
      this.cashDrawerIsSet = true;
    } else {
      this.cashDrawer__I = v || undefined;
      this.cashDrawerIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawer() {
    return this.cashDrawer__I;
  }
  printerPasswordHash__I?: string = undefined;
  printerPasswordHashIsSet: boolean = false;
  set printerPasswordHash(v: undefined | string) {
    if (v !== undefined) {
      this.printerPasswordHash__I = v;
      this.printerPasswordHashIsSet = true;
    } else {
      this.printerPasswordHash__I = v || undefined;
      this.printerPasswordHashIsSet = false;
    }
    this.changeTracker = true;
  }
  get printerPasswordHash() {
    return this.printerPasswordHash__I;
  }
  constructor(config?: PrinterInternalOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.printerMACIsSet == true && other?.printerMACIsSet == true)
      return this.printerMAC == other.printerMAC;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.printerMAC) {
      this.printerMACIsSet = true;
    }

    this.cashDrawer?.setIds();
  }
  assignFrom(
    config: PrinterInternalOptional,
    options?: AssignOptions,
  ): PrinterInternalTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.printerMAC &&
      this.printerMACApplyFilter(optionsRequired.filter)
    ) {
      this.printerMAC = config.printerMAC;
      if (optionsRequired.unassign) this.printerMACIsSet = false;
      else this.printerMACIsSet = true;
    }
    if (
      config.printerUser &&
      this.printerUserApplyFilter(optionsRequired.filter)
    ) {
      this.printerUser = config.printerUser;
      if (optionsRequired.unassign) this.printerUserIsSet = false;
      else this.printerUserIsSet = true;
    }
    if (
      config.printerName &&
      this.printerNameApplyFilter(optionsRequired.filter)
    ) {
      this.printerName = config.printerName;
      if (optionsRequired.unassign) this.printerNameIsSet = false;
      else this.printerNameIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.cashDrawer &&
      this.cashDrawerApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawer = new CashDrawerRefTracked(config.cashDrawer, options);
      if (optionsRequired.unassign) this.cashDrawerIsSet = false;
      else this.cashDrawerIsSet = true;
    }
    if (
      config.printerPasswordHash &&
      this.printerPasswordHashApplyFilter(optionsRequired.filter)
    ) {
      this.printerPasswordHash = config.printerPasswordHash;
      if (optionsRequired.unassign) this.printerPasswordHashIsSet = false;
      else this.printerPasswordHashIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PrinterInternalTrackedI {
    const cloned = {} as PrinterInternalTrackedI;
    if (
      this.printerMACIsSetDeep() &&
      this.printerMACApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerMACIsSet = true;
      cloned.printerMAC = this.printerMAC;
    } else {
      //cloned.printerMACIsSet = false
    }
    if (
      this.printerUserIsSetDeep() &&
      this.printerUserApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerUserIsSet = true;
      cloned.printerUser = this.printerUser;
    } else {
      //cloned.printerUserIsSet = false
    }
    if (
      this.printerNameIsSetDeep() &&
      this.printerNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerNameIsSet = true;
      cloned.printerName = this.printerName;
    } else {
      //cloned.printerNameIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.cashDrawerIsSetDeep() &&
      this.cashDrawerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerIsSet = true;
      cloned.cashDrawer = this.cashDrawer?.removeUnset(filter);
    } else {
      //cloned.cashDrawerIsSet = false
    }
    if (
      this.printerPasswordHashIsSetDeep() &&
      this.printerPasswordHashApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerPasswordHashIsSet = true;
      cloned.printerPasswordHash = this.printerPasswordHash;
    } else {
      //cloned.printerPasswordHashIsSet = false
    }
    if (!isDeleted(this) && !this.printerMACIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PrinterInternalTrackedI {
    if (!this.printerMACApplyFilter(filter)) this.printerMACIsSet = false;

    if (!this.printerUserApplyFilter(filter)) this.printerUserIsSet = false;

    if (!this.printerNameApplyFilter(filter)) this.printerNameIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.cashDrawerApplyFilter(filter)) this.cashDrawerIsSet = false;
    this.cashDrawer?.unassignAll(filter);

    if (!this.printerPasswordHashApplyFilter(filter))
      this.printerPasswordHashIsSet = false;

    return this;
  }
  printerMACApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.printerMAC,
      PrinterInternalMeta,
      this.printerMAC,
      this,
    );
  }
  printerMACIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerMACIsSet && this.printerMACApplyFilter(filter)) return true;

    return false;
  }
  printerUserApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.printerUser,
      PrinterInternalMeta,
      this.printerUser,
      this,
    );
  }
  printerUserIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerUserIsSet && this.printerUserApplyFilter(filter))
      return true;

    return false;
  }
  printerNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.printerName,
      PrinterInternalMeta,
      this.printerName,
      this,
    );
  }
  printerNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerNameIsSet && this.printerNameApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.isDeleted,
      PrinterInternalMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.isNew,
      PrinterInternalMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  cashDrawerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.cashDrawer,
      PrinterInternalMeta,
      this.cashDrawer,
      this,
    );
  }
  cashDrawerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerIsSet && this.cashDrawerApplyFilter(filter)) return true;
    return this.cashDrawer?.anySet(filter) == true;

    return false;
  }
  printerPasswordHashApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PrinterInternalMeta.printerPasswordHash,
      PrinterInternalMeta,
      this.printerPasswordHash,
      this,
    );
  }
  printerPasswordHashIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.printerPasswordHashIsSet &&
      this.printerPasswordHashApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.printerMACIsSetDeep(filter)) return true;
    if (this.printerUserIsSetDeep(filter)) return true;
    if (this.printerNameIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.cashDrawerIsSetDeep(filter)) return true;
    if (this.printerPasswordHashIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
